import { useMaintenance } from "@/contexts/maintenanceContext";
import { useMember } from "@/contexts/memberContext";
import { isMemberASuperAdmin } from "@/core/auth";
import { Construction } from "lucide-react";

const MaintenanceOverlay = () => {
  const { isMaintenanceMode, maintenanceMessage } = useMaintenance();
  const { member } = useMember();

  // Don't show overlay to superadmins - they need to be able to toggle it off
  if (isMemberASuperAdmin(member)) {
    return null;
  }

  // Don't show if not in maintenance mode
  if (!isMaintenanceMode) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[9999] bg-white flex items-center justify-center"
      role="alert"
      aria-live="assertive"
    >
      <div className="text-center px-8 max-w-md">
        <Construction className="size-16 text-amber-500 mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Site Under Maintenance</h1>
        <p className="text-gray-600 mb-4">
          {maintenanceMessage || "We're currently performing scheduled maintenance. Please check back shortly."}
        </p>
        <p className="text-sm text-gray-500">
          We apologise for any inconvenience. If you need urgent assistance, please contact support.
        </p>
      </div>
    </div>
  );
};

export default MaintenanceOverlay;
